import { createFileRoute } from '@tanstack/react-router'

import { validateShipmentListSearch } from '#/entities/shipment'
import { QuotesProductPage } from '#/modules/pipelines/pipeline-pages'

export const Route = createFileRoute('/_shell/quotes')({
  component: QuotesProductPage,
  validateSearch: validateShipmentListSearch,
})
